import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { AddIcon } from '@diligentcorp/atlas-react-icons';
import { paths } from '@issuemanager/apps/client/paths';
import { useTranslation } from 'react-i18next';

export function IssueTypesGridToolbarAddType() {
  const { t } = useTranslation(['settings']);

  return (
    <Link
      to={`/${paths.settings.index}/${paths.issueTypes.index}/${paths.issueTypes.add}`}
    >
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        data-testid='add-category-button'
      >
        {t('settings:issueTypes.form.actions.addSubtype')}
      </Button>
    </Link>
  );
}
